<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkFormwizard from "./BookmarkFormwizard.svelte";
  import Card from "../../../Core/Card.svelte";
  import { PleaseMake, SimpleFormWizard } from "../../../../utils/Constant/Constant";
  import FormWizardContent from "./FormWizardContent.svelte";
</script>
<BookmarkFormwizard />
<Container fluid>
    <Row>
      <Col md="12">
        <Card headerTitle={SimpleFormWizard} cardHeaderprops="pb-0"> 
          <div slot="customheader">
            <span>{PleaseMake}</span>
          </div>
          <div slot="contentbody">
            <FormWizardContent />
          </div>
        </Card>
      </Col>
    </Row>
</Container>